import { render, staticRenderFns } from "./IntronicPositionError.vue?vue&type=template&id=27e161c8"
import script from "./IntronicPositionError.vue?vue&type=script&lang=js"
export * from "./IntronicPositionError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports